import {BaseModel} from "./BaseModel";

export class NoskheModel extends BaseModel {
    constructor(cookie = "") {
        super();
        this.cookie = cookie;

    }

    RouteName = "Noskhe";
    AuthState = true;

    getAllWithPaginate(id,pageNumber, pageSize = 10) {
        try {
            return this.baseApi
                .axiosInstance(this.AuthState, this.cookie)
                .get(
                    `${this.RouteName}/page?id=${id}&pageNumber=${pageNumber}&pageSize=${pageSize}`
                );
        } catch (e) {
            const error = e;
            throw error.response?.data.message;
        }
    }

    async GetSearch(Username = "",
                    Role = "",
                    AzSabt = "",
                    TaSabt = "",
                    Vaziat = "",
    ) {
        try {

            return await this.baseApi
                .axiosInstance(true, this.cookie)
                .get(`${this.RouteName}/search?Username=${Username}&Role=${Role}&AzSabt=${AzSabt}&TaSabt=${TaSabt}&Vaziat=${Vaziat}`)
        } catch (e) {
            const error = e;
            throw error.response?.data;
        }
    }


}
